import React, { useRef, useEffect, useState } from "react";
import MovingLeft from "../../components/common/FullLengthSwipers/MovingLeft";
import { businessCategories } from "../Home/BusinessCategories";
import { Link } from "react-router-dom";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../components/common/Typography/Paragraph";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../Public/shared/publicLayoutSpec";

const ITEM_WIDTH = 200; // px, average width of each item (adjust as needed)
const SLIDER_SPEED = 30; // px per second, desired constant speed

const FullLengthSlider = ({
  className = PUBLIC_SECTION_GAP_CLASS,
  itemGapClassName = PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  labelClassName = PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
}) => {
  const [sliderSpeed, setSliderSpeed] = useState("50s");

  useEffect(() => {
    const totalWidth = businessCategories.length * ITEM_WIDTH;
    const duration = totalWidth / SLIDER_SPEED; // seconds
    setSliderSpeed(`${duration}s`);
  }, []);

  return (
    <>
      <div className={`${className} w-[100%]`}>
        <MovingLeft speed={sliderSpeed}>
          {businessCategories
            .sort((a, b) =>
              a.businessCategoryName.localeCompare(b.businessCategoryName)
            )
            .map((item, index) => (
              <Link to={`/category/${item.slug}`} key={index}>
                <div className="sliderImg">
                  <div className={`w-[160px] sm:w-[200px] xl:w-[250px] 2xl:w-[270px] cursor-pointer ${itemGapClassName}`}>
                    <img
                      className="w-[160px] h-[200px] sm:w-[200px] sm:h-[250px] xl:w-[250px] xl:h-[320px] 2xl:w-[270px] 2xl:h-[340px] object-cover rounded-xl"
                      src={require("../../assets/img/default-image.jpg")}
                      alt="/"
                    />
                    <Paragraph
                      variant={"BodyCompact"}
                      className={`${labelClassName} text-offblack`}
                    >
                      {item.businessCategoryName}
                    </Paragraph>
                  </div>
                </div>
              </Link>
            ))}
        </MovingLeft>
      </div>
    </>
  );
};

export default FullLengthSlider;
